import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "modal","checkbox", "player", "duplicatesContainer", "mergingPlayer", "aiPlayer", "aiMergeGroup"]

  connect() {
    // console.log("Hello, Player Duplicates Controller here!", this.element)
  }

  displayManualMergeModal() {
    // given a list of players, allow the user which one is the primary record all other data should be merged into

    const playerIds = this.checkboxTargets.filter(checkbox => checkbox.checked).map(checkbox => checkbox.value);
    // console.log('Got these players checked', playerIds);
    if (playerIds.length === 0) {
      createAlert('warning', 'Please select at least one player to merge.');
      return;
    }

    const players = this.playerTargets.filter(player => playerIds.includes(player.dataset.playerid));
    // console.log('Got these players checked', players);

    this.duplicatesContainerTarget.innerHTML = players.map(player => {
      return `
        <div class="merging-player fanword-border fanword-border-radius mb-3" data-player-duplicates-target='mergingPlayer'>
          <div class="card-body">
            <div class='d-flex flex-row'>
              <div class='d-flex flex-column align-items-center justify-content-center me-3'>
                <input type="radio" name="matches[0][primary_player_id]" value="${player.dataset.playerid}" id="primary_player_${player.dataset.playerid}" class="form-check-input" data-action='player-duplicates#selectManualPrimaryPlayer' required>
                <input type="hidden" name="matches[0][duplicate_player_ids][]" value="${player.dataset.playerid}">
              </div>
              <div>
                <h5 class="card-title">${player.dataset.name}</h5>
                <p class="card-text m-0">${player.dataset.gameCount || 0} games records - ${player.dataset.bios || 0} bios</p>

                <p class="card-text primary-player-indicator d-none">This is the player record that will all other records will be merged into.</p>
              </div>
            </div>

          </div>
        </div>
      `;
    }
    ).join('');

    const modal = new bootstrap.Modal(this.modalTarget);
    modal.show();
  }

  selectManualPrimaryPlayer(event) {
    // reset all of the merging players
    this.mergingPlayerTargets.forEach(card => {
      card.classList.remove('fanword-border');
      card.classList.add('color-fanword-text')
      card.querySelector('.primary-player-indicator').classList.add('d-none');
    });

    // set the selected player as primary with special styling
    const selectedPlayer = event.target.closest('.merging-player');
    selectedPlayer.classList.add('fanword-border');
    selectedPlayer.classList.remove('color-fanword-text');
    selectedPlayer.querySelector('.primary-player-indicator').classList.remove('d-none');
  }

  removeAIPlayer(event) {
    event.preventDefault();
    event.stopPropagation();

    const playerId = event.params.player;
    const index = event.params.index;
    // console.log('Removing player', playerId, index);

    const playerGroup = this.aiPlayerTargets.find( elm => elm.dataset.playerGroupId === `${index}_${playerId}`);

    // remove the tooltip if still active
    bootstrap.Tooltip.getInstance(event.currentTarget).dispose();

    // remove the form field
    document.querySelector(`input[name="matches[${index}][duplicate_player_ids][]"][value="${playerId}"]`).remove();

    // remove the UI element
    playerGroup.remove();
  }

  makeAIPrimaryPlayer(event) {
    event.preventDefault();
    event.stopPropagation();

    const newPrimaryPlayerId = event.params.player;
    const index = event.params.index;
    // console.log('Making player primary', newPrimaryPlayerId, index);

    const playerGroup = this.aiPlayerTargets.find( elm => elm.dataset.playerGroupId === `${index}_${newPrimaryPlayerId}`);
    bootstrap.Tooltip.getInstance(event.currentTarget).dispose();

    // update the players name as the primary one
    const player_name_slot = document.getElementById(`primary_player_slot_${index}`);
    player_name_slot.innerHTML = playerGroup.innerText.trim()

    // update the form field
    document.querySelector(`input[name="matches[${index}][primary_player_id]"]`).value = newPrimaryPlayerId;

    // swap all of the buttons
    const allPlayerGroups = this.aiPlayerTargets.filter( elm => elm.dataset.playerGroupId.startsWith(`${index}_`));
    allPlayerGroups.forEach( group => {

      // reset the controls
      group.querySelectorAll('.controls').forEach( control => {
        control.classList.remove('d-inline');
        control.classList.add('d-none');
      });

      if (parseInt(group.dataset.playerId, 10) === parseInt(newPrimaryPlayerId, 10)) {
        // set the primary controls to inline
        group.querySelector('.primary-controls').classList.remove('d-none');
        group.querySelector('.primary-controls').classList.add('d-inline');
      } else {
        // set the non-primary controls to inline
        group.querySelector('.non-primary-controls').classList.remove('d-none');
        group.querySelector('.non-primary-controls').classList.add('d-inline');
      }

    });

  }

  toggleAllAIPlayers(event) {
    event.preventDefault();
    event.stopPropagation();

    this.aiMergeGroupTargets.forEach( checkbox => {
      checkbox.checked = !checkbox.checked;
      // console.log('Toggling checkbox', checkbox.checked);
    });
  }

}
